import React from 'react'
import '../../Styles/SliderArea.css'
import '../../assets/css/swiper-bundle.css'
import '../../assets/css/custom-animation.css'
import '../../assets/css/animate.min.css'
import { Link } from "react-router-dom"
import usaHomePageVideo from '../../assets/video/Final home page video.mp4'


const SliderArea = () => {

    return (
        <div>
            <section className="bd-slider-area">
                <div className="bd-slider-active swiper-container">
                    <div >
                        <div className="bd-single-slider bd-single-slider-overlay bd-slider-height d-flex align-items-center swiper-slide">
                            <div className="bd-slide-bg" style={{ opacity: "0.8" }}>
                                <video src={'https://res.cloudinary.com/ztpl-images/video/upload/q_auto,f_auto,fl_lossy/v1746705979/USA%20website/Home%20page/Final_home_page_ankr76.mp4 '} style={{ width: "100%", height: '100%', objectFit: 'cover' }} autoPlay loop playsInline muted></video>
                                {/* <video src={video} autoPlay loop playsInline muted></video> */}
                            </div>
                            <div className="container">
                                <div className="row cont-title">
                                    <div className="col-12 ">
                                        <div className="bd-slider z-index text-center pt-35">
                                            <h1 className="bd-slider-title mb-20" data-animation="fadeInUp" data-delay=".3s">The Powerhouse Behind USA’s Fastest-Growing Businesses</h1>
                                            {/* Expert Bespoke Systems in Canada */}
                                            <p className="mb-40" data-animation="fadeInUp" data-delay=".6s">
                                            Proudly serving American businesses with smart automation, custom software, and digital marketing solutions tailored to the U.S. market.
                                            </p>
                                            {/* Linking entrepreneurs to their KPIs for enhanced performance and expansion in Canada. */}
                                            <div className="bd-slider-btn" data-animation="fadeInUp" data-delay=".9s">
                                                <Link to={"/about-us"} className="theme-btn">Explore Us</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default SliderArea
